import { Link } from 'react-router-dom';
import { can } from '../../supplementary_components/userDataDelegate';
import styles from './classicMenu.module.scss';

const MenuData = [
    { title: 'Dashboard', path: 'dashboard' },
    { title: 'Mainboard', path: 'mainboard' },
    { title: 'Loads', path: 'loads' },
    { title: 'Tenders', path: 'tenders', visible: () => can('TENDERS', 'VIEW') },
    { title: 'Invoices', path: 'invoices', visible: () => can('INVOICES', 'VIEW') },
    { title: 'Trucks', path: 'trucks', visible: () => can('TRUCKS', 'VIEW') },
    { title: 'Trailers', path: 'trailers', visible: () => can('TRAILERS', 'VIEW') },
    { title: 'Trailer Management', path: 'trailer-management', visible: () => can('TRAILER_MANAGEMENT', 'FLAG') },
    { title: 'Drivers', path: 'drivers', visible: () => can('DRIVERS', 'VIEW') },
    { title: 'Onboarding', path: 'hiring', visible: () => can('HIRING', 'VIEW') },
    { title: 'Inspections', path: 'inspections', visible: () => can('INSPECTIONS', 'VIEW') },
    { title: 'Employees', path: 'employees', visible: () => can('USERS', 'VIEW') || can('ROLES', 'VIEW') },
    { title: 'Teams', path: 'teams', visible: () => can('TEAMS', 'VIEW') },
    { title: 'Brokers', path: 'brokers', visible: () => can('BROKERS', 'VIEW') },
    { title: 'Fuel Cards', path: 'fuel-cards', visible: () => can('FUEL_CARDS', 'VIEW') },
    { title: 'Statements', path: 'statements', visible: () => can('STATEMENTS', 'VIEW') },
    { title: 'Reports', path: 'reports' },
];

const isSelected = (itemPath, path) => (
    itemPath === 'reports'
        ? path === 'reports' || String(path).startsWith('reports/')
        : itemPath === path
);

export const ClassicMenu = ({ path }) => (
    <div className={styles.wrapper}>
        <div className={styles.container}>
            {MenuData.map((item) => {
                if (item.visible && !item.visible()) return null;
                return (
                    <Link
                        key={item.path}
                        to={`/${item.path}`}
                        className={`${styles.menuItem} ${isSelected(item.path, path) ? styles.selected : ''}`}
                    >
                        {item.title}
                    </Link>
                );
            })}
        </div>
    </div>
);
